<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismiss('close')">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Payout</ion-title>
    <ion-progress-bar *ngIf="isLoading" type="indeterminate" color="primary"></ion-progress-bar>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid fixed>
    <ion-row *ngIf="!isLoading">
      <ion-col sizeXs="12" sizeSm="6">
        <ion-item color="secondary">
          <ion-label>
            <p>Wallet premios</p>
            <p>
              Saldo disponible:
              <strong>{{ balance | currency }}</strong>
            </p>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-icon slot="start" name="cash-outline"></ion-icon>
          <ion-input
            label="Monto a retirar"
            labelPlacement="floating"
            type="number"
            [value]="amount"
            debounce="250"
            (ionInput)="changeAmount($event)"
          ></ion-input>
        </ion-item>

        <div class="div-nuvei">
          <span class="nuvei-tag">
            Pagos seguros por
            <ion-img src="./assets/wallet/payment_types/nuvei-dark.svg"></ion-img>
          </span>
        </div>
      </ion-col>
      <ion-col sizeXs="12" sizeSm="6">
        <!-- <ion-button (click)="accountCapture()" expand="block" color="secondary" shape="round"> Capturar cuenta </ion-button> -->
        <ion-accordion-group value="list">
          <ion-accordion *ngIf="upoForm && upos.length < 4" value="first">
            <ion-item slot="header" color="light">
              <ion-icon slot="start" name="add"></ion-icon>
              <ion-label>Agrega una cuenta</ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
              @if(upoForm){
              <form [formGroup]="upoForm" (ngSubmit)="onSubmit(false)">
                <ion-list>
                  <ion-item>
                    <ion-label>
                      <p>{{ credentials?.email }}</p>
                      <p>{{ credentials?.customer?.firstName }} {{ credentials?.customer?.lastName }}</p>
                    </ion-label>
                  </ion-item>
                  <ion-item button detail (click)="openSearchBank()">
                    <ion-label>
                      @if(f['beneficiaryBank'].value) {
                      <p>
                        <strong>{{ (banks | search : f['beneficiaryBank'].value)[0].Bank }}</strong>
                      </p>
                      } @else{
                      <p><strong>Seleccionar banco</strong></p>
                      }
                    </ion-label>
                  </ion-item>

                  <ion-item>
                    <ion-input
                      label="Número de cuenta (CLABE)"
                      label-placement="floating"
                      formControlName="beneficiaryNumber"
                      type="tel"
                      inputmode="numeric"
                      pattern="\d*"
                      maxlength="18"
                      [counter]="true"
                      (ionInput)="onClabeInput($event)"
                    ></ion-input>
                  </ion-item>

                  <ion-note
                    color="danger"
                    class="ion-padding-start"
                    *ngIf="clabeCtrl && clabeCtrl.invalid && (clabeCtrl.dirty || clabeCtrl.touched)"
                  >
                    {{ clabeError() }}
                  </ion-note>
                </ion-list>

                <ion-button expand="block" type="submit" [disabled]="upoForm.invalid">
                  <ion-icon slot="start" name="save-outline"></ion-icon>
                  Guardar
                </ion-button>
              </form>
              }
            </div>
          </ion-accordion>
          <ion-accordion value="list">
            <ion-item id="itemSelectUpo" slot="header" color="light">
              <ion-icon slot="start" name="key-outline"></ion-icon>
              <ion-label>Selecciona tu cuenta</ion-label>
            </ion-item>
            @if (upos.length && payoutForm){
            <div class="ion-padding" slot="content">
              <form [formGroup]="payoutForm" (ngSubmit)="onSubmit(true)">
                <ion-list>
                  <ion-radio-group formControlName="stp">
                    <ion-list-header>
                      <ion-label>Cuenta a depositar</ion-label>
                    </ion-list-header>
                    @for(upo of upos; track upo.id){
                    <ion-item>
                      <ion-button (click)="deleteUpo(upo)" slot="start" color="danger">
                        <ion-icon slot="icon-only" name="trash"></ion-icon>
                      </ion-button>
                      <ion-radio [value]="upo.id">
                        <p>
                          <small
                            >{{ upo.apmData.beneficiaryNumber | slice : 0 : 1 }}****{{
                              upo.apmData.beneficiaryNumber | slice : -4
                            }}</small
                          ><br />
                          {{ upo.bankName }}
                        </p>
                      </ion-radio>
                    </ion-item>
                    }
                  </ion-radio-group>
                </ion-list>
                <ion-button
                  block
                  color="primary"
                  type="submit"
                  expand="block"
                  [disabled]="payoutForm.invalid || amount > balance"
                >
                  <ion-icon slot="start" name="send-outline"></ion-icon>
                  Transferir {{ amount | currency }}
                </ion-button>
              </form>
            </div>
            } @else{
            <div class="ion-padding" slot="content">
              <ion-card>
                <ion-card-header>
                  <ion-card-subtitle>Puedes agregar con el boton de arriba</ion-card-subtitle>
                  <ion-card-title>No se encontraron cuentas para depositar</ion-card-title>
                </ion-card-header>
              </ion-card>
            </div>
            }
          </ion-accordion>
        </ion-accordion-group>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="isLoading">
      <!-- <ion-col [ngStyle]="{ display: isLoading ? 'none' : undefined }" size="12">
        <div id="nuvei-withdrawal-container" style="width: 100%; height: 300px"></div>
      </ion-col> -->
      <ion-col *ngIf="isLoading" size="12">
        <ion-list>
          <!-- <ion-list-header>
            <ion-skeleton-text [animated]="true" style="width: 80px"></ion-skeleton-text>
          </ion-list-header> -->
          <ion-item *ngFor="let item of [0, 1, 2, 3, 4]">
            <ion-thumbnail slot="start">
              <ion-skeleton-text [animated]="true"></ion-skeleton-text>
            </ion-thumbnail>
            <ion-label>
              <h3>
                <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
              </h3>
              <p>
                <ion-skeleton-text [animated]="true" style="width: 60%"></ion-skeleton-text>
              </p>
              <p>
                <ion-skeleton-text [animated]="true" style="width: 30%"></ion-skeleton-text>
              </p>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
